export default "__VITE_ASSET__5219b76e__"